// status of list refresh
import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filterSelectors } from '../Modules/filters';
import { DEFAULT_EMPTY_VALUE } from '../../../../../utils/constants';
import { v4 } from 'uuid';
import isEmpty from 'lodash/isEmpty';

export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);
export const getFilters = createSelector(
  filterSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
export const getVisitorTypeListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  list => {
    if (!list) return [];
    return list.map(m => {
      if (!m.id) {
        return {
          ...m,
          id: v4(),
        };
      }
      return m;
    });
  },
);
export const getVisitorTypeRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details || Object.keys(details).length === 0) {
      return {};
    }
    return details;
  },
);

export const getVisitorTypeTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (isEmpty(details)) {
      return {};
    }
    return {
      generalInfo: {
        typeName: {
          type: 'text',
          label: 'Type',
          value: details.typeName || DEFAULT_EMPTY_VALUE,
        },
        archived: {
          type: 'boolean',
          value: details.archived,
        },
        systemRequired: {
          type: 'boolean',
          value: details.systemRequired,
        },
      },
    };
  },
);
